import clsx from 'clsx'
import { VideoFigure } from '../figure/video-figure'
import { type DocsDemosState, DEMOS_PAGE_URL } from '~/services/docs-demos'
import { CarouselRail } from '~/components-v2/carousel-rail/carousel-rail'

type EngineeringDemoProps = {
  className?: string
  docsDemos?: DocsDemosState
}

export const EngineeringDemo = ({
  className,
  docsDemos,
  ...props
}: EngineeringDemoProps) => {
  if (!docsDemos) return null

  const demosToShow = docsDemos.demos.demos
    .filter((demo) => demo.videoUrl)
    .slice(0, 3)
  if (demosToShow.length === 0) return null
  const remainingDemos = Math.max(
    docsDemos.demos.demos.length - demosToShow.length,
    0,
  )

  return (
    <section
      {...props}
      className={clsx([
        'page-section page-section--lg engineering-demo',
        className,
      ])}
    >
      <div className="page-section__inner engineering-demo__inner">
        <CarouselRail
          className="engineering-demo__rail"
          desktopEndSpacerSlides={1}
          desktopVisibleSlides={2}
          header={
            <hgroup className="engineering-demo__header">
              <h2 className="heading-xl text-brand-dark">
                Peek at what we’re building
              </h2>
              <p className="body-l text-primary">
                Every week, our engineers share what they’re shipping. Take a
                look!
              </p>
            </hgroup>
          }
          viewAll={{
            external: true,
            href: DEMOS_PAGE_URL,
            label: `See ${remainingDemos} More Demos from Last Week`,
          }}
          viewportControls
        >
          {demosToShow.map((demo, index) => {
            const innerContent = demo.description.content?.[0]?.content?.[0]
            const summary =
              innerContent && 'value' in innerContent
                ? innerContent.value
                : null

            return (
              <article className="demo-card" key={`demo-${index}`}>
                {demo.videoUrl && (
                  <VideoFigure src={demo.videoUrl} title={demo.title} />
                )}

                <div className="demo-card__content">
                  <h3 className="demo-card__title heading-s">
                    {demo.title}
                    <span aria-hidden="true" />
                  </h3>
                  <p className="demo-card__presenters body-s">
                    {demo.presenters
                      .map((presenter) => presenter.name)
                      .join(', ')}
                  </p>

                  {summary && (
                    <p className="demo-card__summary body-m">{summary}</p>
                  )}
                </div>
              </article>
            )
          })}
        </CarouselRail>
      </div>
    </section>
  )
}
